<template lang="pug">
  .layout
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    v-card-text.pa-0(v-else-if="profitLoss")
      .pa-4(:style="{'background-color': $vuetify.theme.themes[$theme].primary500}")
        v-layout
          .income.mr-2
            .c1(:style="{ 'color': $vuetify.theme.themes[$theme].basic100T64 }") INCOME -
          .product.mr-2
            .c1(:style="{ 'color': $vuetify.theme.themes[$theme].basic100T64 }") ( PRODUCT COST +
          .opex.mr-2
            .c1(:style="{ 'color': $vuetify.theme.themes[$theme].basic100T64 }") OPEX )
        v-layout
          .income.mr-2
            .s2.basic100--text
              span.mr-2 {{ profitLoss.income.total | displayPrice }}
              span -
          .product.mr-2
            .s2.basic100--text
              span.mr-2 ( {{ profitLoss.product_cost.total | displayPrice }}
              span +
          .opex.mr-2
            .s2.basic100--text
              span.mr-2 {{ profitLoss.opex.total | displayPrice }} )
              span

        v-layout.mt-4
          .s2.basic100--text.mt-auto.mb-1.mr-4 =
          .total
            .c1(:style="{ 'color': $vuetify.theme.themes[$theme].basic100T64 }") NET PROFIT
            .h5.basic100--text.mr-2 {{ profitLoss.net_profit.total | displayPrice }}

      .pa-4
        v-layout(v-if="!isPrinting")
          v-spacer
          v-btn.elevation-0.pa-0.mr-2(text color="transparent" :ripple="false" x-small light @click="clickPrint()")
            v-icon.mr-1(size="15" color="primary400") mdi-cloud-print-outline
            .label.primary400--text Print
          v-btn.elevation-0.pa-0(text color="transparent" :ripple="false" x-small light @click="filterSheet = true")
            eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="15" style="margin-top: 2px")
            .label.primary400--text Filter
        .header.text-center.mt-3
          .h5.primary500--text {{ companyName }}
          .p1.primary500--text.mt-2 Profit & Loss
          .p2.primary400--text {{ profitLoss.date_range[0] | displayDate }} - {{ profitLoss.date_range[1] | displayDate }}
          //.p2.primary400--text {{ selectedTypeFilter.name }} Basis
        .details.mx-2.mt-6
          .income
            v-layout(@click="hiddenFields.showIncome = !hiddenFields.showIncome")
              .s2.primary500--text INCOME
              eva-icon.ml-1.mt-1(:name="showIncomeProductsDetails? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
              v-spacer
              .s2.primary500--text {{ profitLoss.income.total | displayPrice }}

            .ml-4(v-show="hiddenFields.showIncome")
              .income-general.mt-3
                v-layout
                  .s2.primary500--text General
                  v-spacer
                  .s2.primary500--text {{ profitLoss.income.daily_income | displayPrice }}

              .income-product.mt-3(v-if="profitLoss.income.products.length > 0")
                v-layout(@click="hiddenFields.showIncomeProductsDetails = !hiddenFields.showIncomeProductsDetails")
                  .s2.primary500--text Product
                  eva-icon.ml-1.mt-1(:name="hiddenFields.showIncomeProductsDetails? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-spacer
                  .s2.primary500--text {{ profitLoss.income.products.reduce((sum, i) => sum + i['total'], 0) | displayPrice }}
                .ml-4(v-show="hiddenFields.showIncomeProductsDetails")
                  v-row.mt-2(v-for="(product, index) in profitLoss.income.products" :key="index + product.name")
                    v-col.py-0
                      .p2.primary500--text {{ product.name }}
                    v-col.py-0
                      .p2.primary500--text.text-right {{ product.total | displayPrice }}

              .income-addon.mt-3(v-if="profitLoss.income.addons.length > 0")
                v-layout(@click="hiddenFields.showIncomeAddonsDetails = !hiddenFields.showIncomeAddonsDetails")
                  .s2.primary500--text Add-on
                  eva-icon.ml-1.mt-1(:name="hiddenFields.showIncomeAddonsDetails? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-spacer
                  .s2.primary500--text {{ profitLoss.income.addons.reduce((sum, i) => sum + i['total'], 0) | displayPrice }}
                .ml-4(v-show="hiddenFields.showIncomeAddonsDetails")
                  v-layout.mt-2(v-for="(addon, index) in profitLoss.income.addons" :key="index + addon.name")
                    .p2.primary500--text {{ addon.name }}
                    v-spacer
                    .p2.primary500--text {{ addon.total | displayPrice }}
              .income-partial.mt-3(v-if="profitLoss.income && profitLoss.income.partial_paid")
                v-layout
                  .s2.primary500--text Partial Paid / Deposit
                  v-spacer
                  .s2.primary500--text {{ profitLoss.income.partial_paid | displayPrice }}
          div.mt-2.dotted

          .product.mt-3
            v-layout
              .s2.primary500--text PRODUCT COST
              v-spacer
              .s2.primary500--text - {{ profitLoss.product_cost.total | displayPrice }}
          v-divider.basic600.mt-2

          .opex.mt-3
            v-layout
              .s2.primary500--text GROSS PROFIT
              v-spacer
              .s2.primary500--text {{ profitLoss.gross_profit.total | displayPrice }}
          div.mt-2.dotted

          .opex.mt-3
            v-layout(@click="hiddenFields.showOpexDetails = !hiddenFields.showOpexDetails")
              .s2.primary500--text OPERATING EXPENSE
              eva-icon.ml-1.mt-1(:name="hiddenFields.showOpexDetails? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="16" height="16" :fill="$vuetify.theme.themes[$theme].basic700")
              v-spacer
              .s2.primary500--text - {{ profitLoss.opex.total | displayPrice }}
            .ml-4(v-show="hiddenFields.showOpexDetails")
              v-layout.mt-2(v-for="category in profitLoss.opex.categories" :key="category.name")
                .p2.primary500--text {{ category.name }}
                v-spacer
                .p2.primary500--text {{ category.total | displayPrice }}
          v-divider.basic600.mt-2

          .nett.mt-3
            v-layout
              .s2.primary500--text NET PROFIT
              v-spacer
              .s2.primary500--text {{ profitLoss.net_profit.total | displayPrice }}
          v-divider.basic600.mt-2
          v-divider.basic600.mt-1.mb-12

    .modals
      ProfitAndLossFilter(v-if="filterSheet" :company="company" :filtered="filteredData" :open.sync="filterSheet" @filtered="handleFiltered")

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ProfitAndLossFilter from '@/components/yezzabook/ProfitAndLossFilter.vue'

export default {
  name: 'ProfitAndLoss',
  props: ['pid'],
  components: { ProfitAndLossFilter },
  data: () => ({
    isFetching: false,
    profitLoss: null,
    filterSheet: false,
    hiddenFields: {
      showIncome: false,
      showIncomeProductsDetails: false,
      showIncomeAddonsDetails: false,
      showOpexDetails: false,
    },
    selectedTypeFilter: { name: 'Accrual', id: 'accrual' },
    selectedDateRangeFilter: { name: 'This year to date', id: 'ytd' },
    selectedDateRange: [],
    timeZone: 'Asia/Kuala_Lumpur',
    key: '',
    companySlug: '',
    companyName: '',
    printFilterParams: {}
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    filterParams () {
      let params = {}
      if (this.selectedTypeFilter) {
        params.report_type = this.selectedTypeFilter.id
      }
      if (this.selectedDateRangeFilter) {
        if (this.selectedDateRangeFilter.id === 'custom') {
          if (this.selectedDateRange.length === 1) {
            params.from = this.selectedDateRange[0]
            params.until = this.selectedDateRange[0]
          } else {
            if (this.selectedDateRange[0] < this.selectedDateRange[1]) {
              params.from = this.selectedDateRange[0]
              params.until = this.selectedDateRange[1]
            } else {
              params.from = this.selectedDateRange[1]
              params.until = this.selectedDateRange[0]
            }
          }
          params.date_range = 'custom'
        } else {
          params.date_range = this.selectedDateRangeFilter.id
        }
      }
      return params
    },
    filteredData () {
      let data = {}
      this.selectedTypeFilter ? data.status = this.selectedStatusFilter : null
      this.selectedDateRangeFilter ? data.range = this.selectedDateRangeFilter : null
      this.selectedDateRangeFilter ? data.selectedDateRange = this.selectedDateRange : null
      return data
    },
    isPrinting () {
      if (this.$route.path.includes('print-reports')) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.isPrinting) {
      const data = JSON.parse(atob(this.pid))
      this.companySlug = data.company_slug
      this.companyName = data.company_name
      this.key = data.key
      this.printFilterParams = data.filter_params
      this.hiddenFields = data.hidden_fields
    } else {
      this.companySlug = this.company.slug
      this.companyName = this.company.name
    }
    this.getProfitLoss()
  },
  methods: {
    getProfitLoss () {
      this.isFetching = true
      this.$axios.get(`/books/${this.companySlug}/profit_and_loss?key=${this.key}`, { params: this.isPrinting? this.printFilterParams : this.filterParams })
        .then((response) => {
          this.profitLoss = response.data
          this.isFetching = false
        })
        .catch(() => {})
    },
    handleFiltered (data) {
      this.selectedTypeFilter = data.type || null
      this.selectedDateRangeFilter = data.range || null
      if (data.range) {
        this.selectedDateRange = data.selectedDateRange
      }
      this.getProfitLoss()
    },
    clickPrint () {
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
      .then(response => {
        this.key = response.data.key
        const data = {
          company_slug: this.companySlug,
          company_name: this.companyName,
          key: this.key,
          filter_params: {...this.filterParams},
          hidden_fields: this.hiddenFields
        }
        const dataString = btoa(JSON.stringify(data))
        console.log(dataString)
        let printUrl = `https://pdf.yezza.io/?url=http://localhost:8080/print-reports/${dataString}`
        if (this.$subdomain) {
          printUrl = `https://pdf.yezza.io/?url=${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/print-reports/${dataString}`
        }
        printUrl += `&type=pdf&filename=report.pdf&waitUntil=networkidle0&printBackground=true&format=A4`
        if (this.$isMobile) {
          window.open(printUrl)
        } else {
          location.href = printUrl
        }
      })
      .catch(() => {})
    }
  }
}
</script>

<style scoped>
.dotted {
  border-top: 1px dashed var(--v-basic600);
}
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "proceed": "Proceed"
  }
}
</i18n>
